export const config = {
  title: "Hollywood SoulSalon | Ouchless Hair Braiding | San Diego, CA",
  meta: {
    description:
      "Hollywood SoulSalon specializes in ouchless hair braiding in San Diego, CA. Expert box braids, knotless styles, cornrows, boho braids, faux locs, and more. Painless braiding with love - book online today! Rated excellent with 32+ reviews.",
    keywords: [
      "Hollywood SoulSalon",
      "Ouchless Hair Braiding",
      "San Diego Hair Braiding",
      "Box Braids San Diego",
      "Knotless Braids",
      "Painless Braiding",
      "African Hair Braiding",
      "Boho Braids San Diego",
      "Faux Locs San Diego"
    ],
    author: "Hollywood SoulSalon",
    canonicalUrl: "https://hollywoodsoulsalon.com/",
  },
  sections: {
    header: {
      businessName: "Hollywood SoulSalon",
      tagline: "Ouchless Hair Braiding",
    },
    sectionB: {
      heroTitle: "Braids With Love, From the Heart to Your Hair",
      heroSubtitle: "Expert Ouchless Hair Braiding in San Diego",
      learnAboutText: "Book Your Appointment",
      phoneNumber: "6789135510",
      phoneLabel: "(678) 913-5510",
      heroBackgroundImage:
        "https://images.unsplash.com/photo-1560066984-138dadb4c035?w=1200&q=80",
      cardData: [
        {
          title: "Ouchless Braids",
          description:
            "Experience painless braiding with our gentle, expert technique. Your comfort is our priority.",
        },
        {
          title: "Premium Beauty",
          description:
            "High-quality hair products and expert styling for stunning, long-lasting results.",
        },
        {
          title: "Confidence in Every Style",
          description:
            "Personalized looks that celebrate your unique beauty and boost your confidence.",
        },
      ],
      description:
        "Welcome to Hollywood Soul Salon—where style meets comfort. Your journey to effortless beauty begins here, with expert hair braiding, online booking, and premium beauty products all in one place.",
    },
    sectionC: {
      servicesTitle: "Our Hair Braiding Services",
      servicesDescription:
        "Expert braiding and premium beauty care designed to keep you stylish and confident. Our talented stylists are dedicated to creating stunning, personalized looks while ensuring your comfort every step of the way. Appointments typically take 2 to 2½ hours.",
      cards: [
        {
          title: "Box Braids & Knotless Styles",
          description:
            "Beautiful box braids and knotless styles with hair included. Choose from classic or trendy colors. Painless technique for maximum comfort.",
          imageSrc: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=600&q=80",
          imageAlt: "Box braids hair styling",
        },
        {
          title: "Boho Braids & Faux Locs",
          description:
            "Trendy boho braids with colors and authentic-looking faux locs. Expert installation for a natural, beautiful finish.",
          imageSrc: "https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=600&q=80",
          imageAlt: "Boho braids styling",
        },
        {
          title: "Cornrows & Fulani Braids",
          description:
            "Precision cornrows and elegant Fulani braids. Traditional styles with modern flair, all hair included.",
          imageSrc: "https://images.unsplash.com/photo-1580618672591-eb180b1a973f?w=600&q=80",
          imageAlt: "Cornrows and braiding",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Crochet Styles",
        "Twists",
        "French Curly Braids",
        "Hair Wash Service & Blow Dry",
        "Sew-Ins",
        "Beauty Supply Products",
      ],
    },
    sectionD: {
      aboutTitle: "About Hollywood SoulSalon",
      aboutImage: {
        src: "https://hollywoodsoulsalon.com/wp-content/uploads/2025/08/logoWhatsApp-Image-2025-05-12-at-20.05.13_1afa55a1-300x268-1.webp",
        alt: "Hollywood SoulSalon hair braiding",
      },
      aboutText: [
        "Hollywood Soul Salon is your premier destination for ouchless hair braiding in San Diego. We specialize in expert hair braiding where our talented stylists are dedicated to creating stunning, personalized looks while ensuring your comfort every step of the way.",
        "As one delighted client shares: 'The service is amazing and my braids didn't take long at all and were painless.' With over 32 excellent reviews, our commitment to painless, beautiful braiding has made us a trusted choice in the San Diego community.",
        "We offer a wide range of services including box braids, knotless styles, boho braids, cornrows, twists, crochet, faux locs, and Fulani braids—all with hair included. Our convenient online booking system makes scheduling easy, and we also carry premium beauty supply products to enhance your hair care routine. Services start at approximately $30 for cornrows and up to $100+ for box braids or knotless styles. Book your appointment today and experience braids with love!",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Hollywood SoulSalon Logo",
      businessName: "Hollywood SoulSalon",
      subtitle: "Ouchless Hair Braiding",
      contact: {
        phone: "6789135510",
        phoneLabel: "(678) 913-5510",
        email: "ezeisoken@gmail.com",
        website: "https://hollywoodsoulsalon.com/",
        address: "7710 Balboa Ave. STE 214A, San Diego, CA 92111",
      },
      socialMedia: {
        instagram: "https://www.instagram.com/hollywoodsoulsalon_ouchless",
        facebook: "https://www.facebook.com/HollywoodSoulSalon",
        twitter: "",
        linkedin: "",
      },
    },
    sectionF: {
      address: "7710 Balboa Ave. STE 214A, San Diego, CA 92111",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3354.234!2d-117.1567!3d32.8234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dbfd4e4e4e4e4e%3A0x1234567890abcdef!2s7710%20Balboa%20Ave%20STE%20214A%2C%20San%20Diego%2C%20CA%2092111!5e0!3m2!1sen!2sus!4v1730400000000!5m2!1sen!2sus",
    },
  },
};

export default config;